import { r as SettingsAppearanceContainerLayoutEnum } from './index-chunk-wpeform-react-daf2eca0.js';
function setupWPEFormGlobals(globals) {
  if (typeof window !== 'undefined') {
    window.WPEFormGraphQLApp = globals;
  }
}
/**
 * Parse styleData as retrieved from `forms` query.
 *
 * @param styleData StyleData as received from forms query.
 * @returns Parsed value.
 */
function parseStyleData(styleData) {
  let themeStyle = {
    scheme: 'vividBlue',
    containerLayout: SettingsAppearanceContainerLayoutEnum.FLUID,
    maxWidth: '600px'
  };
  let controls = 2;
  let panels = 2;
  try {
    const parsedStyleData = JSON.parse(styleData);
    if (typeof parsedStyleData === 'object') {
      themeStyle = parsedStyleData.themeStyle ?? themeStyle;
      controls = parsedStyleData.controls ?? controls;
      panels = parsedStyleData.panels ?? panels;
    }
  } catch (e) {
    // brood silently
  }
  return {
    themeStyle,
    controls,
    panels
  };
}
export { parseStyleData as p, setupWPEFormGlobals as s };